import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { PiggyBank, Home, TrendingUp, Award, ChevronRight, ArrowLeft } from 'lucide-react';

const NAVY = '#0f2d6b';
const GOLD = '#e8a020';

const ITEMS = [
  {
    icon: PiggyBank,
    title: 'AB Épargne',
    subtitle: 'Épargne & investissement',
    desc: 'Faites fructifier votre capital avec nos plans d\'épargne personnalisés et un taux d\'intérêt attractif.',
    path: '/ab-epargne',
    bg: '#F0FDF4', color: '#16A34A',
  },
  {
    icon: Home,
    title: 'AB Logement',
    subtitle: 'Solutions immobilières',
    desc: 'Accédez à nos services de financement immobilier et de gestion locative.',
    path: '/ab-logement',
    bg: '#EFF6FF', color: '#2563EB',
  },
  {
    icon: TrendingUp,
    title: 'Coaching Finance',
    subtitle: 'Accompagnement business',
    desc: 'Développez votre entreprise avec notre expertise en finance entrepreneuriale.',
    path: '/coaching-finance',
    bg: '#F5F3FF', color: '#7C3AED',
  },
  {
    icon: Award,
    title: 'Score de Fidélité',
    subtitle: 'Programme de récompenses',
    desc: 'Découvrez vos avantages et récompenses pour votre fidélité à nos services.',
    path: '/loyalty-score',
    bg: '#FFF7ED', color: '#EA580C',
  },
];

const Menu = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const name = user?.first_name || user?.user_metadata?.first_name || '';

  return (
    <div className="min-h-screen bg-slate-50 pb-24">

      {/* ── Hero ── */}
      <div className="relative overflow-hidden" style={{ background: `linear-gradient(135deg, ${NAVY} 0%, #1a3f8f 100%)` }}>
        <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/5 pointer-events-none" />
        <div className="absolute -bottom-4 -left-4 w-24 h-24 rounded-full pointer-events-none" style={{ background: `${GOLD}15` }} />

        <div className="relative z-10 max-w-2xl mx-auto px-4 sm:px-6 py-5">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate('/dashboard')}
              className="w-8 h-8 rounded-xl bg-white/10 hover:bg-white/20 flex items-center justify-center flex-shrink-0 transition-colors">
              <ArrowLeft size={16} className="text-white" />
            </button>
            <div>
              <p className="text-white/50 text-[10px] font-medium tracking-wide">AB Campus Finance</p>
              <h1 className="text-white font-bold text-base leading-tight">
                Nos services{name ? <span style={{ color: GOLD }}>, {name}</span> : ''}
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* ── Cards ── */}
      <div className="max-w-2xl mx-auto px-4 sm:px-6 pt-4 space-y-3">
        {ITEMS.map(item => (
          <button key={item.path} onClick={() => navigate(item.path)}
            className="w-full flex items-center gap-4 bg-white rounded-2xl shadow-sm border border-slate-100 px-4 py-4 hover:shadow-md active:scale-[0.99] transition-all group text-left">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ background: item.bg }}>
              <item.icon size={22} style={{ color: item.color }} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-bold text-slate-900 text-sm">{item.title}</p>
              <p className="text-slate-400 text-xs">{item.subtitle}</p>
              <p className="text-slate-500 text-xs mt-0.5 leading-snug hidden sm:block truncate">{item.desc}</p>
            </div>
            <ChevronRight size={16} className="text-slate-300 group-hover:text-slate-500 flex-shrink-0 transition-colors" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Menu;
